module.exports = function(app) {

	//TODO test to make sure inArray helper works on older browsers (since it uses Array.prototype.indexOf)

	//Register custom view helpers

	app.view.fn('inArray', {
		//Returns true if needle is found in haystack
		get: function getInArray(needle, haystack) {
			if (!haystack) return false;
			return (haystack.indexOf(needle) != -1);
		}

	  , set: function setInArray(value, needle, haystack) {
			if (haystack) {
				//copy the array (it won't work without this due to how reactive functions work in Derby)
				haystack = haystack.splice(0);
			}
			else haystack = [];

			if (value) {
				haystack.push(needle);
			}
			else {
				//remove the element from the array
				var index = haystack.indexOf(needle);
				if (index != -1) haystack.splice(index, 1);
			}

			return [needle, haystack];
		}
	});

	app.view.fn('join', function(value, separator) {
		if (!separator) separator = ', ';
		if (value && Array.isArray(value))
			return value.join(separator);
	});

	app.view.fn('ucfirst', function(str) {
		if (str) {
		  str += '';
		  var f = str.charAt(0).toUpperCase();
		  return f + str.substr(1);
		}
	});
	
	//convert newlines to line breaks
	app.view.fn('nl2br', function(str) {
		if (typeof str == 'string') {
		  return str.replace(/[\r\n]/, '<br>');
		}
		else if (str!==null && str!==undefined) console.log('Notice: non-string value passed to nl2br view helper');
	});

	app.view.fn('encodeUri', function(uri) {
		return uri && encodeURIComponent(uri);
	});

	app.view.fn('stripPunctuation', function(str) {
		if (str) return str.replace(/[^\w\s]/g, '');
	});

	app.view.fn('stripSpacesAndPunctuation', function(str) {
		if (str) return str.replace(/\W/g, '');
	});

	app.view.fn('truncate', function(str, length) {
		if (typeof str != 'string') {
			log('Non-string value passed to truncate() view helper')
			return;
		}
		if (!length) length = 50;
		if (str)
			return str.length <= length ? str: str.substr(str, length) + '...';
	});
	
	//Format Date object or timestamp
	app.view.fn('date', function(date, format) {	
		//polyfills for the Date object
        require('date-utils');
        
		if (!date) return;        
        if (!format) format = 'M/D/YYYY H:MI PP';
        
        if (typeof date != 'object' || !(date instanceof Date)) {
        	date = new Date(date);
        }
        return date.toFormat(format);
	});
};